import ProgressBarMedium from './component.jsx'
export default ProgressBarMedium
